import { render, staticRenderFns } from "./MultipleGroups.vue?vue&type=template&id=2bbcdb18&"
import script from "./MultipleGroups.vue?vue&type=script&lang=js&"
export * from "./MultipleGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports